import * as angular from 'angular';

class ConnectionQueryHeaderEditorController {
  static $inject: Array<string> = ['$transclude', '$scope'];

  private prependScriptSourceModel: string;

  constructor(private $transclude: angular.ITranscludeFunction, private $scope: angular.IScope) {
    this.$transclude((clonedElem) => {
      const preElemNode: Element = clonedElem.filter((index, elem) => elem.tagName === 'PRE')[0];
      const code: string = angular.element(preElemNode).text();

      this.$scope.$evalAsync(() => {
        this.prependScriptSourceModel = `${code}`;
      });
    });
  }
}

export const ConnectionQueryHeaderEditorComponent: angular.IComponentOptions = {
  controller: ConnectionQueryHeaderEditorController,
  controllerAs: 'ctrl',
  bindings: {},
  transclude: true,
  template: `
    <div class="connection-query-header-editor">
      <textarea
        name="prepend_script[raw_source]"
        class="form-control form-control-sm hide"
        id="prepend_script_raw_source"
        ng-model="ctrl.prependScriptSourceModel"
        spellcheck="false"
        aria-invalid="false"
      ></textarea>
      <ace-textarea textarea-model="ctrl.prependScriptSourceModel" mode="sql"></ace-textarea>
    </div>
  `,
};
